import { useState, useEffect, useCallback } from 'react';
import styles from './ImageLightbox.module.css';

export default function ImageLightbox({ images, currentIndex, onClose }) {
  const [index, setIndex] = useState(currentIndex || 0);

  const goNext = useCallback(() => setIndex(i => (i + 1) % images.length), [images.length]);
  const goPrev = useCallback(() => setIndex(i => (i - 1 + images.length) % images.length), [images.length]);

  useEffect(() => {
    function handleKey(e) {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowRight') goNext();
      if (e.key === 'ArrowLeft') goPrev();
    }
    document.addEventListener('keydown', handleKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = '';
    };
  }, [onClose, goNext, goPrev]);

  const src = images[index];

  return (
    <div className={styles.overlay} onClick={onClose}>
      {/* Close */}
      <button className={styles.close} onClick={onClose}>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
      </button>

      {/* Prev */}
      {images.length > 1 && (
        <button className={styles.arrow + ' ' + styles.arrowLeft} onClick={e => { e.stopPropagation(); goPrev(); }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
        </button>
      )}

      {/* Image */}
      <img
        src={src}
        alt=""
        className={styles.image}
        onClick={e => e.stopPropagation()}
      />

      {/* Next */}
      {images.length > 1 && (
        <button className={styles.arrow + ' ' + styles.arrowRight} onClick={e => { e.stopPropagation(); goNext(); }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
        </button>
      )}

      {/* Counter */}
      {images.length > 1 && (
        <div className={styles.counter}>{index + 1} / {images.length}</div>
      )}
    </div>
  );
}
